import React, { useEffect, useRef } from "react";
import { LTBox, LTText } from "@lambdatestincprivate/lt-components";

const DoughnutChart = ({ issueSummary, totalCount }) => {
  const canvasRef = useRef();

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = 80;
    const lineWidth = 30;
    const startAngle = -Math.PI / 2;

    // Disable anti-aliasing
    ctx.imageSmoothingEnabled = false;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const totalValue = issueSummary.reduce(
      (total, segment) => total + segment.value,
      0
    );
    let currentAngle = startAngle;

    issueSummary.forEach((segment) => {
      const segmentPercentage = segment.value / totalValue;
      const endAngle = currentAngle + 2 * Math.PI * segmentPercentage;

      // Draw the main segment
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, currentAngle, endAngle);
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = segment.color;
      ctx.stroke();

      currentAngle = endAngle;
    });
  }, [issueSummary]);

  return (
    <LTBox
      position="relative"
      width="200px"
      height="200px"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <LTBox
        width="inherit"
        height="inherit"
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <canvas
          ref={canvasRef}
          width="200"
          height="200"
          style={{ position: "absolute", top: 0, left: 0 }}
        />
        <LTBox display="flex" flexDirection="column" alignItems="center">
          <LTText as="span" fontSize={LTText.FontSize.FONT_20} fontWeight="600">
            {totalCount}
          </LTText>
          <LTText
            as="span"
            fontSize={LTText.FontSize.FONT_14}
            fontWeight="400"
            color="fg.muted"
          >
            Issues
          </LTText>
        </LTBox>
      </LTBox>
    </LTBox>
  );
};

export default DoughnutChart;
